// components/facturas/FacturaCard.jsx
// Tarjeta para el Contexto
import "./FacturaCard.css";
import { formatearPrecio } from "../../../../utils/precios.js";


export default function FacturaCard({
  factura,
  abierta,
  metodoPago,
  onToggle,
  onMetodoPago,
  onPagar,
  onCancelar,
}) {
  const mesas = [...new Set(factura.pedidos.map((p) => p.mesaId))];
  return (
    <div className="factura-card" onClick={onToggle}>
      {/* CABECERA */}
      <div className="factura-row">
        <div className="factura-info">
          <span className="factura-mesa">
            Factura {factura.numeroFactura} – Mesas: {mesas.join(", ")}
          </span>

          <span className="factura-fecha">
             Fecha:{" "}
          {new Date(factura.fecha).toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })}{" "}
          {new Date(factura.fecha).toLocaleTimeString("es-ES", {
            hour: "2-digit",
            minute: "2-digit",
          })}
          </span>
        </div>

        <span className="factura-total">
            ${formatearPrecio(factura.total)}
        </span>
      </div>

      {/* DETALLE */}
      {abierta && (
        <div className="factura-detalle">
          {factura.pedidos.map((pedido) => (
            <div key={pedido.mesaId} className="factura-pedido">
              <strong>Mesa {pedido.mesaId}</strong>

              {pedido.productos.map((p, i) => (
                <div key={i} className="detalle-item">
                  <span>
                    {p.cantidad} × {p.nombre}
                  </span>
                  <span>
                    ${Number(p.cantidad * p.precio).toLocaleString("es-ES")}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* ACCIONES */}
      <div className="factura-pago" onClick={(e) => e.stopPropagation()}>
        <select
          value={metodoPago || ""}
          onChange={(e) => onMetodoPago(e.target.value)}
        >
          <option value="">Método de pago</option>
          <option value="efectivo">Efectivo</option>
          <option value="nequi">Nequi</option>
          <option value="daviplata">Daviplata</option>
          <option value="brebe">Bre-B</option>
        </select>

        <button className="btn-pagar" onClick={onPagar}>
          Pagar
        </button>

        <button className="btn-cancelar" onClick={onCancelar}>
          ✕
        </button>
      </div>
    </div>
  );
}
